import React from "react"
import styled from "styled-components"

import Grid, { Col } from "components/grid"
import { BrowserView } from "components/helpers/hide"
import { Box, BoxProps } from "components/box"
import { H4, Paragraph } from "components/text"
import { PrimaryButton } from "components/buttons"

type SplitSectionProps = {
  leftContent: {
    headline?: string
    text?: string
    cta?: {
      label: string
      to: string
    }
  }
  rightContent?: React.ReactNode
  bgImage?: string
  bgImageMobile?: string
  flip?: boolean
} & BoxProps

const Container = styled(Box)<BoxProps & { bgImage?: string; bgImageMobile?: string }>`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  ${props => (props.bgImageMobile ? `background-image: url(${props.bgImageMobile}); background-position: bottom;` : "")}

  @media screen and (min-width: ${props => props.theme.breakpoints.md}px) {
    ${props => (props.bgImage ? `background-image: url(${props.bgImage});` : "")}
  }
`

function SplitSection({ leftContent, rightContent, bgImage, bgImageMobile, flip, ...styleProps }: SplitSectionProps) {
  const { headline, text, cta } = leftContent

  return (
    <Container bgImage={bgImage} bgImageMobile={bgImageMobile} {...styleProps}>
      <Grid
        rowProps={{
          flexDirection: [null, null, flip ? "row-reverse" : "row"],
          justifyContent: ["center", "center", "flex-start"]
        }}
      >
        <Col cols={[4, 4, 6, 5]}>
          {headline && <H4 mb={5}>{headline}</H4>}
          {text && <Paragraph mb={7}>{text}</Paragraph>}
          {cta && (
            <BrowserView>
              <PrimaryButton to={cta.to} sizing="lg">
                {cta.label}
              </PrimaryButton>
            </BrowserView>
          )}
        </Col>
        {rightContent && (
          <Col cols={[4, 4, 6, 5]} push={[0, 0, 0, 1]}>
            {rightContent}
          </Col>
        )}
      </Grid>
    </Container>
  )
}

export default SplitSection
